import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Tabs as MTabs } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    minHeight: 'fit-content',
    '& .MuiTabs-scrollButtonsDesktop': { color: theme.palette.primary.main },
  },
  default: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
  },
}))

const Tabs = ({ customVariant, ...props }) => {
  const classes = useStyles()
  return (
    <MTabs
      TabIndicatorProps={{ className: classes[customVariant] }}
      className={clsx(classes.root)}
      {...props}
    />
  )
}
Tabs.propTypes = {
  customVariant: PropTypes.string.isRequired,
}

export default Tabs
